import PropTypes from 'prop-types';
import React from 'react';

import Afterpay from 'components/Afterpay';
import { Small, MediumUp } from 'components/MediaQuery';
import PdpShopPayButton from 'components/PdpShopPayButton';
import ShoprunnerPdpCTA from 'components/Shoprunner/ShoprunnerPdpCTA';
import AddToCartModal from 'containers/PdpAddToCartModalContainer';
import Product from 'models/Product';
import Variant from 'models/Variant';
import I18n from 'utils/I18n';

import AddToCartSection from './AddToCartSection';
import MobileAddToCart from './MobileAddToCart';
import PdpQuantitySelector from '../PdpQuantitySelector';

class PdpAddToCart extends React.PureComponent {
  render() {
    const {
      product,
      currentVariant,
      isBackordered,
      isSoldOut,
      isProductUpdatesEnabled,
      addToCart,
      openProductUpdatesModal,
      openPdpColorwayUpdatesFormModal,
      variantId,
      isAddToCartModalEnabled,
      features,
      policyText,
      recommendationsOption,
      selectedQuantity,
      shopPayCampaignData,
    } = this.props;

    let label = '';
    let isDisabled = false;
    let handleClick = cartMetadata =>
      addToCart(cartMetadata, isAddToCartModalEnabled, recommendationsOption);
    let isActive = false;

    if (!variantId) {
      label = I18n.localize('pdp.addToCart.selectSize');
      isDisabled = true;
    } else if (isSoldOut && isProductUpdatesEnabled) {
      label = I18n.localize('pdp.addToCart.joinWaitlist');
      handleClick = openProductUpdatesModal;
    } else if (isSoldOut) {
      label = I18n.localize('pdp.addToCart.getNotified');
      handleClick = openPdpColorwayUpdatesFormModal;
    } else if (isBackordered) {
      label = I18n.localize('pdp.addToCart.backordered');
    } else {
      label = I18n.localize('pdp.addToCart.available');
      isActive = true;
    }

    const priceSource = currentVariant || product;

    return (
      <>
        <Small>
          <PdpQuantitySelector {...this.props} />
          <MobileAddToCart
            {...this.props}
            handleClick={handleClick}
            isDisabled={isDisabled}
            label={label}
            isActive={isActive}
            priceSource={priceSource}
          />
        </Small>
        <MediumUp>
          <PdpQuantitySelector {...this.props} />
          <AddToCartSection
            {...this.props}
            handleClick={handleClick}
            isDisabled={isDisabled}
            label={label}
            isActive={isActive}
            priceSource={priceSource}
          />

          {currentVariant && features.showShopPay && (
            <div className="my-3">
              <PdpShopPayButton
                currentVariant={currentVariant}
                selectedQuantity={selectedQuantity}
                shopPayCampaignData={shopPayCampaignData}
              />
            </div>
          )}

          {features.showAfterpayBeneathAddToCart && (
            <div className="DesktopAddToCart__afterpay mt-3 text-center">
              <Afterpay price={product.price} masterId={product.masterId} />
            </div>
          )}

          {features.showShoprunner && <ShoprunnerPdpCTA />}

          {policyText && (
            <div className="DesktopAddToCart__policy mt-3 text-center">
              <span className="DesktopAddToCart__policy-text text-xs leading-normal tracking-tight">
                {policyText}
              </span>
            </div>
          )}
        </MediumUp>
        {isAddToCartModalEnabled && (
          <AddToCartModal
            product={product}
            currentVariant={currentVariant}
            recommendationsOption={recommendationsOption}
          />
        )}
      </>
    );
  }
}

PdpAddToCart.propTypes = {
  product: PropTypes.instanceOf(Product).isRequired,
  currentVariant: PropTypes.instanceOf(Variant),
  addToCart: PropTypes.func.isRequired,
  openProductUpdatesModal: PropTypes.func.isRequired,
  openPdpColorwayUpdatesFormModal: PropTypes.func.isRequired,
  recommendationsOption: PropTypes.string.isRequired,
  isAddToCartModalEnabled: PropTypes.bool.isRequired,

  isBackordered: PropTypes.bool,
  isSoldOut: PropTypes.bool,
  isProductUpdatesEnabled: PropTypes.bool,
  variantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  policyText: PropTypes.string,
  features: PropTypes.shape({
    showAfterpayBeneathAddToCart: PropTypes.bool,
    showShopPay: PropTypes.bool,
    showShoprunner: PropTypes.bool,
  }),
  selectedQuantity: PropTypes.number.isRequired,
  selectQuantity: PropTypes.func,
  bulkAddOptions: PropTypes.arrayOf(
    PropTypes.shape({
      bulkAddAmount: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    })
  ),
  shopPayCampaignData: PropTypes.shape({
    decisionId: PropTypes.string,
    variationId: PropTypes.number,
    experienceName: PropTypes.string,
    campaignName: PropTypes.string,
  }),
};

PdpAddToCart.defaultProps = {
  currentVariant: null,
  isBackordered: false,
  isSoldOut: false,
  isProductUpdatesEnabled: false,
  features: {},
  variantId: '',
  policyText: '',
  selectedQuantity: 1,
  shopPayCampaignData: null,
};

export default PdpAddToCart;
